import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';

import env from 'Env';
import { countryCode, xboxAvailable } from 'Helpers/Geo/data';
import TrackingLink from 'Layout/NavBar/MegaMenu/Categories/TrackingLink';
import Price from 'Components/Price/Price';
import pricing from 'Helpers/Price/games-under-pricing';

export default function SpecialSections({ setMegaMenuTab, megaMenuTab }) {
  const [userOs, setUserOs] = useState('');

  useEffect(() => {
    const platform = get(window, 'navigator.platform');
    if (platform.includes('Mac')) setUserOs('mac');
    if (platform.includes('Linux')) setUserOs('linux');
  }, []);

  return (
    <ul className="CategoriesMegaMenu__linksContainer" role="menu">
      {megaMenuTab === 'categories' &&
        <li className="CategoriesMegaMenu__link">
          <TrackingLink to="/showcase" id="categories-showcase" setMegaMenuTab={setMegaMenuTab}>
            <FormattedMessage
              id="special-sections.link.showcase"
              defaultMessage="Showcase"
              tagName="span"
            />
            <div className="CategoriesMegaMenu__link__label">
              <FormattedMessage
                id="special-sections.link.showcase.new"
                defaultMessage="New"
              />
            </div>
          </TrackingLink>
        </li>
      }

      <li className="CategoriesMegaMenu__link">
        <TrackingLink to="/games-under/5" id="categories-gamesunder5" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage
            id="special-sections.link.under-five"
            defaultMessage="Games Under {price}"
            tagName="span"
            values={{
              price: <Price
                hideDecimals
                price={pricing['5'].max}
              />,
            }}
          />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link">
        <TrackingLink to="/games-under/10" id="categories-gamesunder10" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage
            id="special-sections.link.under-ten"
            defaultMessage="Games Under {price}"
            tagName="span"
            values={{
              price: <Price
                hideDecimals
                price={pricing['10'].max}
              />,
            }}
          />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link">
        <TrackingLink to="/franchises" id="categories-browsebyfranchise" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="special-sections.link.franchises" defaultMessage="Browse by Franchise" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link">
        <TrackingLink to="/publishers" id="categories-browsebypublisher" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="special-sections.link.publishers" defaultMessage="Browse by Publisher" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link">
        <TrackingLink to="/vr-games" id="categories-vrgames" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="special-sections.link.vr" defaultMessage="VR Games" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link">
        <TrackingLink to="/steam-deck-games" id="categories-steamdeckgames" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="special-sections.link.steam-deck-games" defaultMessage="Steam Deck Games" />
        </TrackingLink>
      </li>
      {xboxAvailable &&
        <li className="CategoriesMegaMenu__link">
          <TrackingLink to="/publishers/xbox" id="categories-xboxgames" setMegaMenuTab={setMegaMenuTab}>
            <FormattedMessage id="special-sections.link.xbox-games" defaultMessage="Xbox Games" />
          </TrackingLink>
        </li>
      }
      {userOs === 'mac' &&
        <li className="CategoriesMegaMenu__link">
          <TrackingLink to="/mac-games" id="categories-masosgames" setMegaMenuTab={setMegaMenuTab}>
            <FormattedMessage id="special-sections.link.mac-games" defaultMessage="Mac OS Games" />
          </TrackingLink>
        </li>
      }
      {userOs === 'linux' &&
        <li className="CategoriesMegaMenu__link">
          <TrackingLink to="/linux-games" id="categories-linuxosgames" setMegaMenuTab={setMegaMenuTab}>
            <FormattedMessage id="special-sections.link.linux-games" defaultMessage="Linux OS Games" />
          </TrackingLink>
        </li>
      }
      <li className="CategoriesMegaMenu__link">
        <TrackingLink to="/search?types=software%2Csoftware-bundle" id="categories-software" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="special-sections.link.software" defaultMessage="Software" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link">
        <TrackingLink to="/games-like" id="categories-gameslike" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="special-sections.link.games-like" defaultMessage="Games Like ..." />
        </TrackingLink>
      </li>
      {env.giftCardCountries.includes(countryCode) &&
        <li className="CategoriesMegaMenu__link">
          <TrackingLink to="/gift-cards" id="categories-giftcards" setMegaMenuTab={setMegaMenuTab}>
            <FormattedMessage id="special-sections.link.gift-cards" defaultMessage="Gift Cards" />
          </TrackingLink>
        </li>
      }
      <li className="CategoriesMegaMenu__link">
        <TrackingLink to="/search" id="categories-browseall" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="special-sections.link.browse-all" defaultMessage="Browse All" />
        </TrackingLink>
      </li>
    </ul>
  );
}

SpecialSections.propTypes = {
  setMegaMenuTab: PropTypes.func,
  megaMenuTab: PropTypes.string,
};

SpecialSections.defaultProps = {
  setMegaMenuTab: () => { },
  megaMenuTab: '',
};
